import getElementSelectors from '../../shares/lib/getElementSelectors';
import { getSDKConfig } from '../../shares/lib/getSDKConfig';

const COLLAPSED_CLASS = 'sdk-idle-collapsed';
const DEFAULT_COLLAPSE_AFTER_S = 5;

export class IdleCollapseController {
  private isCollapsed = false;
  private enabled = false;

  public start(): void {
    const config = getSDKConfig();
    const collapseConfig = config?.swipeGames?.swipeIconCollapse;

    this.enabled = collapseConfig?.enabled ?? false;
    if (!this.enabled) return;

    const { swipe_control } = getElementSelectors();
    const arrowWrapper = swipe_control?.querySelector<HTMLElement>(
      '.swipe-control__arrow-wrapper',
    );
    if (!swipe_control || !arrowWrapper) return;

    const collapseAfter =
      collapseConfig?.collapseIconAfter ?? DEFAULT_COLLAPSE_AFTER_S;
    swipe_control.style.setProperty('--sdk-collapse-after', `${collapseAfter}s`);

    arrowWrapper.addEventListener('animationend', () => this.collapse());
  }

  public expand(): void {
    if (!this.enabled) return;
    if (!this.isCollapsed) return;

    const { swipe_control } = getElementSelectors();
    swipe_control?.classList.remove(COLLAPSED_CLASS);
    this.isCollapsed = false;
  }

  private collapse(): void {
    const { swipe_control } = getElementSelectors();
    swipe_control?.classList.add(COLLAPSED_CLASS);
    this.isCollapsed = true;
  }

  public pauseCountdown(): void {
    if (!this.enabled) return;
    const { swipe_control } = getElementSelectors();
    const arrowWrapper = swipe_control?.querySelector<HTMLElement>(
      '.swipe-control__arrow-wrapper',
    );
    if (arrowWrapper) arrowWrapper.style.animationPlayState = 'paused';
  }

  public resumeCountdown(): void {
    if (!this.enabled) return;
    const { swipe_control } = getElementSelectors();
    const arrowWrapper = swipe_control?.querySelector<HTMLElement>(
      '.swipe-control__arrow-wrapper',
    );
    if (arrowWrapper) arrowWrapper.style.animationPlayState = 'running';
  }
}

export const idleCollapse = new IdleCollapseController();
